// Listen for Woo's added_to_cart event so the cart bubble animates briefly when stock changes.
// Woo's own JS handles fragment swap; we only add a flourish.
// jQuery is loaded globally by WooCommerce — use window.jQuery, don't bundle.

(function () {
    function init($) {
        $(document.body).on('added_to_cart', function () {
            var bubble = document.querySelector('[data-cart-bubble]');
            if (!bubble) return;
            bubble.classList.add('is-bumped');
            setTimeout(function () { bubble.classList.remove('is-bumped'); }, 600);
        });
    }

    if (window.jQuery) {
        init(window.jQuery);
    } else {
        document.addEventListener('DOMContentLoaded', function () {
            if (window.jQuery) init(window.jQuery);
        });
    }
})();
